"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.select = exports.multiSelect = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));
var _react = require("@testing-library/react");
var _userEvent = _interopRequireDefault(require("@testing-library/user-event"));
var _openHelpers = require("./openHelpers");
var simpleSelectOption = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(input, option) {
    return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0, _react.act)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
              var DOWN_ARROW;
              return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      DOWN_ARROW = {
                        keyCode: 40
                      };
                      _react.fireEvent.focus(input);
                      _react.fireEvent.keyDown(input, DOWN_ARROW);
                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            })));
          case 2:
            _context3.next = 4;
            return (0, _react.act)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
              var optionElement;
              return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return _react.screen.findByText(option);
                    case 2:
                      optionElement = _context2.sent;
                      _context2.next = 5;
                      return _userEvent.default.click(optionElement);
                    case 5:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            })));
          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function simpleSelectOption(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var selectSearchSelectOption = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5(input, option) {
    return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return (0, _react.act)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
              var optionElement, select;
              return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return _userEvent.default.click(input);
                    case 2:
                      _context4.next = 4;
                      return _react.screen.findByText(option);
                    case 4:
                      optionElement = _context4.sent;
                      select = optionElement.parentElement;
                      _context4.next = 8;
                      return _userEvent.default.selectOptions(select, option);
                    case 8:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4);
            })));
          case 2:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return function selectSearchSelectOption(_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}();
var selectHandlers = {
  simple: simpleSelectOption,
  prefixed: simpleSelectOption,
  filter: simpleSelectOption,
  search: selectSearchSelectOption
};

/**
 * Util function that is an abstraction for different types of inputs
 * @param input for Select, PrefixedSelect and FilterSelect pass the dummy element found by id: document.querySelect('#selectId') for SearchSelect you can use test id/label text
 * @param option option to choose
 * @param selectType what type of select is it - simple, prefixed, filter, search
 * @param options if you want to pass additional params to the handler (like config to react-select) use this parameter to pass it
 * @returns Promise which you need to await to make sure the option is selected
 */
var select = function select(input, option) {
  var selectType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'simple';
  for (var _len = arguments.length, options = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    options[_key - 3] = arguments[_key];
  }
  return selectHandlers[selectType].apply(selectHandlers, [input, option].concat(options));
};
exports.select = select;
var multiSelect = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee7(input, options) {
    return (0, _regeneratorRuntime2.default)().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return (0, _react.act)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6() {
              return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
                while (1) {
                  switch (_context6.prev = _context6.next) {
                    case 0:
                      (0, _openHelpers.openMenu)(input);
                    case 1:
                    case "end":
                      return _context6.stop();
                  }
                }
              }, _callee6);
            })));
          case 2:
            _context7.next = 4;
            return (0, _react.waitFor)(function () {
              _react.screen.getByText(options[0]);
            });
          case 4:
            options.forEach(function (o) {
              _react.fireEvent.click(_react.screen.getByText(o));
            });
          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return function multiSelect(_x5, _x6) {
    return _ref6.apply(this, arguments);
  };
}();
exports.multiSelect = multiSelect;